import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./LawExceptions.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getImportantToKnowDetails,
  getImportantToKnowList,
} from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { Seo } from "../../Seo";

const LawExceptions = () => {
  const data = useSelector(
    (state: RootState) => state.info.importantToKnowDetails,
  );
  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const importantToKnowList = useSelector(
    (state: RootState) => state.info.importantToKnowList,
  );
  const lang = useSelector((state: RootState) => state.info.lang);
  const langs: Record<string, string> = {
    ru: "button_ru",
    kg: "button_ky",
    tj: "button_tg",
    uz: "button_uz",
  };

  useEffect(() => {
    dispatch(getImportantToKnowList());
    dispatch(getImportantToKnowDetails(Number(params.id)));
  }, [params]);
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getPath = (button: string, id: number) => {
    switch (button) {
      case "Информация для мигрантов, живущих с ВИЧ, которые имеют право законно оставаться на территории РФ":
        return `/russia/hiv/migrants/${id}`;
      case "Краткосрочные визиты":
        return `/russia/hiv/visits/${id}`;
      case "Могут ли ЛЖВ-мигранты законно пребывать в России (исключения из закона)":
        return `/russia/hiv/law-exceptions/${id}`;
      default:
        return `/russia/hiv`;
    }
  };
  return (
    <div>
      <Seo
        title="ВИЧ и переезд к семье в Россию."
        description="Как легально остаться в РФ с ВИЧ при наличии родственников с гражданством или ВНЖ."
        url="https://www.vputi.org/russia/hiv/law-exceptions/1"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / ВИЧ / Исключения из закона",
            path: "/russia/hiv/6",
          }}
        />
        <ContactButtons />

        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>

          <div className={s.yellow_wrapper}>
            <div
              className={s.body2}
              dangerouslySetInnerHTML={{ __html: data?.body_3 ?? "" }}
            ></div>
          </div>
        </div>
        <div className={s.buttons}>
          {Array.isArray(importantToKnowList) &&
            [...importantToKnowList]
              .reverse()
              .filter((el) => el.id !== Number(params.id))
              .map((it) => {
                const field = langs[lang] || "button_ru";
                const buttonText = (it as any)[field] || it.button;

                return (
                  <Link
                    to={getPath(it.button, it.id)}
                    key={it.id}
                    className={s.button}
                    onClick={() => getImportantToKnowDetails(it.id)}
                  >
                    {buttonText}
                  </Link>
                );
              })}
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default LawExceptions;
